export default "__VITE_ASSET__B60_UMyz__"